var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9583 8.05496V6.65997C18.9583 5.93311 18.8189 5.21335 18.5481 4.54181C18.2772 3.87027 17.8803 3.26016 17.3798 2.74619C16.8794 2.23221 16.2852 1.82445 15.6313 1.5463C14.9774 1.26814 14.2766 1.12497 13.5688 1.12497H6.45589C5.0277 1.12893 3.65908 1.71333 2.64919 2.75049C1.6393 3.78765 1.07026 5.19322 1.06641 6.65997V23.355C1.07027 24.8204 1.63978 26.2244 2.65008 27.2592C3.66039 28.2939 5.02904 28.875 6.45589 28.875H13.5835C14.2886 28.8769 14.9872 28.736 15.6392 28.4602C16.2913 28.1845 16.8839 27.7793 17.3832 27.2679C17.8825 26.7566 18.2786 26.149 18.5489 25.4801C18.8192 24.8112 18.9583 24.0942 18.9583 23.37V21.96",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9047 15H11.3779",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 10.62L28.9044 14.985L24.625 19.365",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.cde1d1b900cf2fa8d77f130717295b7b.svg";
export { ForwardRef as ReactComponent };